"use client"

import { useEffect, useRef } from "react"

/**
 * Product page error boundary.
 * For hydration/DOM errors: auto-reset ONCE to recover.
 * This won't interrupt add-to-cart because addToCart no longer
 * triggers revalidateTag (the source of the error loop).
 */
export default function ProductError({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  const hasReset = useRef(false)

  useEffect(() => {
    console.warn("[Product Page] Error caught:", error.message)

    const isHydrationError =
      error.message?.includes("removeChild") ||
      error.message?.includes("not a child") ||
      error.message?.includes("Hydration") ||
      error.message?.includes("#418") ||
      error.message?.includes("#310")

    if (isHydrationError && !hasReset.current) {
      hasReset.current = true
      reset()
      return
    }
  }, [error, reset])

  // For real errors, show retry
  return (
    <div className="flex flex-col items-center justify-center min-h-[200px] gap-4 p-8">
      <p className="text-sm text-gray-500">Something went wrong loading this page.</p>
      <button
        onClick={() => reset()}
        className="px-4 py-2 text-sm bg-black text-white rounded hover:bg-gray-800"
      >
        Try again
      </button>
    </div>
  )
}
